import { createFileRoute } from "@tanstack/react-router";
import { FileExportsPage } from "@/features/file-exports/file-exports-page";
import { ensureElementVisible } from "@/lib/route-guards";

export const Route = createFileRoute("/_auth/konfiguracja/eksporty-plikowe")({
	component: FileExportsPage,
	beforeLoad: async ({ context, location }) => {
		await ensureElementVisible(
			context.queryClient,
			"sidebar.system.eksporty-plikowe",
			location.pathname,
		);
	},
});
